<template>
    <div v-if="open" id="g2-dialog">
        <div id="g2-dialog-content">
            <div id="g2-dialog-header">
                G2 Communicator
            </div>
            <div id="g2-dialog-body">
                <p>{{ message }}</p>
            </div>
            <div id="g2-dialog-footer">
                <button type="button" class="btn btn-danger" v-if="showCancel" @click="handleCancel">Cancel</button>
                <button type="button" class="btn btn-hub-primary ml-auto" @click="handleConfirm">OK</button>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            open: false,
            message: 'Are you sure?',
            showCancel: true
        }
    },
    methods: {
        show() {
            this.open = true
        },
        close() {
            this.open = false
            this.resolveFunc = null
        },
        handleConfirm() {
            if (this.resolveFunc) {
                this.resolveFunc(true) // Resolve the Promise with true if the user confirms
                this.close()
            }
        },
        handleCancel() {
            if (this.resolveFunc) {
                this.resolveFunc(false) // Resolve the Promise with false if the user cancels
                this.close()
            }
        },
        confirm(message) {
            this.message = message
            this.showCancel = true
            this.show()
            return new Promise((resolve) => {
                this.resolveFunc = resolve
            })
        },
        alert(message) {
            this.message = message
            this.showCancel = false
            this.show()
            return new Promise((resolve) => {
                this.resolveFunc = resolve
            })
        }
    }
}
</script>
 
<style scoped>
#g2-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1030;
}

#g2-dialog-content {
    position: relative;
    min-width: 20vw;
    max-width: 60vw;
    top: -10rem;
    background: white;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    text-align: center;
}

#g2-dialog-header {
    text-align: left;
    background-color: #036;
    color: white;
    padding: 0.8rem 1rem;
    border-radius: 5px 5px 0 0;
}

#g2-dialog-body {
    padding: 1rem;
}

#g2-dialog-footer {
    display: flex;
}

button {
    margin: 0 1rem 1rem 1rem;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
}
</style>